const richpanelMessengerIFrameID = 'richpanel_messenger_iframe'
import { PARENT_WINDOW_MESSAGE_EVENTS } from '../constants';

export default {
    methods: {
        
        shrinkIFrame() {
			this.setIFrame()
			if (this.IFrame) {
				this.IFrame.style.width = '100px'
				this.IFrame.style.height = '100px'
			}
		},
        
        expandIFrame() {
			this.setIFrame()
			if (this.IFrame) {
				this.IFrame.style.width = '100%'
				this.IFrame.style.height = '100%'
			}
		},
        
        setIFrame() {
			if (!this.IFrame) {
				this.IFrame = parent.document.querySelector(`#${richpanelMessengerIFrameID}`)
			}
        },
        
        beforeEnter() {
            this.expandIFrame()
        },

        enter() {
            this.expandIFrame()
        },

        afterEnter() {
            parent.postMessage(PARENT_WINDOW_MESSAGE_EVENTS.MESSENGER_ENTER_ANIMATION_COMPLETED);
            this.expandIFrame()
        },

        enterCancelled() {
            this.shrinkIFrame()
        },

        beforeLeave() {
            this.expandIFrame()
        },

        leave() {
            this.expandIFrame()
        },

        afterLeave() {
            parent.postMessage(PARENT_WINDOW_MESSAGE_EVENTS.MESSENGER_EXIT_ANIMATION_COMPLETED);
            this.shrinkIFrame()
        },

        leaveCancelled() {
            this.expandIFrame()
        }
    }
}